(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dpr-quick-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dpr-quick-add')) {
  customElements.define('dpr-quick-add', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.querySelector('form').addEventListener('submit', (event) => {
        event.preventDefault();
        const button = this.querySelector('button[type=submit]');
        if (button.getAttribute('aria-busy') === 'true') return;
        const data = new FormData(event.currentTarget);
        const status = this.querySelector('[role=status]');
        clearTimeout(this.timer);
        status.textContent = '';
        button.setAttribute('aria-busy', 'true');
        const add = async () => {
          try {
            const drawer = document.querySelector('cart-drawer');
            if (drawer) {
              data.set('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
              data.set('sections_url', window.location.pathname);
            }
            const response = await fetch(window.routes.cart_add_url, {
              method: 'POST', headers: {'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest'}, body: data
            });
            const result = await response.json();
            if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
            status.textContent = this.dataset.added;
            if (drawer) {
              drawer.classList.remove('is-empty');
              try { drawer.renderContents(result, false); } catch (error) { console.error(error); }
            }
            this.timer = setTimeout(() => { status.textContent = ''; }, 4000);
          } catch (error) {
            status.textContent = error.message || this.dataset.error;
          } finally {
            button.removeAttribute('aria-busy');
          }
        };
        window.dprQuickAddQueue = (window.dprQuickAddQueue || Promise.resolve()).then(add, add);
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dpr-reservation-assets"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dpr-reservations')) {
    class DprReservations extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (this.isConnected && !this.controller) this.initialize();
        });
      }

      initialize() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.rail = this.querySelector('[data-reservation-rail]');
        this.railControls = this.querySelector('[data-reservation-rail-controls]');
        this.prepareRail(options);
        this.form = this.querySelector('.dpr-reservation-form');
        if (!this.form) return;
        this.lookToggles = Array.from(this.form.querySelectorAll('[data-look-toggle]'));
        this.lookCount = this.form.querySelector('[data-look-count]');
        this.lookToggles.forEach(toggle => {
          toggle.addEventListener('change', () => this.updateSelection(), options);
        });
        this.form.addEventListener('submit', () => this.updateSelection(), options);
        this.form.addEventListener('invalid', event => {
          const details = event.target.closest('details');
          if (details) details.open = true;
        }, { ...options, capture: true });
        this.updateSelection();
        this.result = this.form.querySelector('[data-reservation-result]');
        if (this.result) {
          this.result.closest('details').open = true;
          this.result.scrollIntoView({ block: 'center', behavior: 'auto' });
          this.result.focus({ preventScroll: true });
        }
      }

      updateSelection() {
        this.lookToggles.forEach(toggle => {
          const fieldset = toggle.closest('[data-look-item]').querySelector('[data-look-size]');
          fieldset.hidden = !toggle.checked;
          fieldset.disabled = !toggle.checked;
          toggle.setAttribute('aria-expanded', String(toggle.checked));
        });
        if (this.lookCount) {
          this.lookCount.textContent = String(1 + this.lookToggles.filter(toggle => toggle.checked).length);
          this.lookCount.hidden = false;
        }
      }

      prepareRail(options) {
        if (!this.rail || !this.railControls) return;
        this.railControls.querySelectorAll('[data-reservation-scroll]').forEach(button => {
          button.addEventListener('click', () => {
            const card = this.rail.firstElementChild;
            const gap = Number.parseFloat(getComputedStyle(this.rail).columnGap) || 0;
            const distance = card ? card.getBoundingClientRect().width + gap : this.rail.clientWidth;
            this.rail.scrollBy({
              left: Number(button.dataset.reservationScroll) * distance,
              behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
            });
          }, options);
        });
        this.rail.addEventListener('scroll', () => this.updateRail(), { ...options, passive: true });
        this.addEventListener('shopify:block:select', event => {
          if (this.rail.contains(event.target)) event.target.closest('li')?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
        }, options);
        this.resizeObserver = new ResizeObserver(() => this.updateRail());
        this.resizeObserver.observe(this.rail);
        this.updateRail();
      }

      updateRail() {
        const maximum = this.rail.scrollWidth - this.rail.clientWidth;
        this.railControls.hidden = maximum < 2;
        this.railControls.querySelector('[data-reservation-scroll="-1"]').disabled = this.rail.scrollLeft < 2;
        this.railControls.querySelector('[data-reservation-scroll="1"]').disabled = this.rail.scrollLeft >= maximum - 2;
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.controller = null;
      }
    }
    customElements.define('dpr-reservations', DprReservations);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dpr-social-proof-locale"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.querySelector('[data-dpr-social-proof]');
  if (!config) return;
  let attempts = 0;
  const connect = () => {
    const shadow = document.getElementById('pop-convert-app')?.shadowRoot;
    if (!shadow) {
      if (++attempts < 60) setTimeout(connect, 1000);
      return;
    }
    const translate = () => {
      shadow.querySelectorAll('.social-pop').forEach(pop => {
        const first = pop.querySelector('p.first');
        const second = pop.querySelector('p.second');
        if (!first || !second) return;
        const count = first.textContent.trim().match(/^(\d+)\s+(?:personas|people)$/);
        const source = second.textContent.trim();
        if (!count) return;
        const cart = source.match(/^Actualmente tienen (.+) en su carrito de compras$/);
        const visited = ['Están viendo esta página ahora mismo', 'Han visitado la tienda en la última hora', config.dataset.visited].includes(source);
        if (!cart && !visited) return;
        const description = cart ? config.dataset.cart.replace('[product]', cart[1]) : config.dataset.visited;
        const title = count[1] + ' ' + config.dataset.people;
        if (first.textContent !== title) first.textContent = title;
        if (second.textContent !== description) second.textContent = description;
      });
    };
    translate();
    new MutationObserver(translate).observe(shadow, {childList: true, subtree: true, characterData: true});
  };
  connect();
})();
  } catch(e) { console.error(e); }
})();

})();
